import { Injectable } from '@angular/core';
import { Changeable } from '../shared/interfaces/changeable';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
    private component!: Changeable | null;

    public setComponent(component: Changeable): void {
        this.component = component;
    }

    public resetComponent(): void {
        this.component = null;
    }

    public shouldContinue(): boolean {
        if (!this.component || this.component === undefined || !this.component.hasChanges()) {
            return true;
        }

        return confirm('Unsaved values will be lost, do you want to leave this page?');
    }

    public hasChanges(): boolean {
        if (!this.component || this.component === undefined || !this.component.hasChanges()) {
            return false;
        }

        return true;
    }
}
